import React, { useEffect, useState } from 'react';
import {connect} from 'react-redux';

import Paper from '@material-ui/core/Paper';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './AvailableErpAgentsPanel.module.css';

const AvailableErpAgentsPanel = ({
    companyInfo,
    erpAgents,
    fetchErpStatuses,
    setErpAgent,
    ...props
}) => {
    const [activeItem, setActiveItem] = useState();

    useEffect(() => {
        setActiveItem(null);
    }, [companyInfo]);

    const handleClick = (agent, id) => {
        setActiveItem(id);
        setErpAgent(agent);

        fetchErpStatuses(agent.id);
    };

    return (
        <Paper className={classes.availableErpAgentsPanel}>
            <div className={classes.panelContainer}>
                <div className={classes.listHeader}>
                    <img src="/assets/images/erpAgentIconColor.svg" alt="Available ERP Agents" />
                    <span>Available ERP Agents</span>
                </div>
                <ul className={classes.listContainer}>
                    {erpAgents.length ?
                        erpAgents.map((agent, id) => {
                            return (
                                <li
                                    key={id}
                                    className={id === activeItem ? classes.selectedItem : ''}
                                    onClick={() => handleClick(agent, id)}
                                    role="none"
                                >
                                    {agent.name}
                                </li>
                            );
                        }) :
                        <li className={classes.emptyItem}>
                            No ERP Agents found
                        </li>
                    }
                </ul>
            </div>
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        companyInfo: state.companyInfo,
        erpAgents:   state.erpAgent.erpAgents
    };
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailableErpAgentsPanel);
